const DispatcherChannels = {
  ClinicTimeChoose: 'clinicTimeChoose', CartItemsUpdate: ""

};

export default DispatcherChannels;
